import { styled } from 'baseui';
const Divider = styled('hr', ({
  $theme
}) => ({
  width: '100%',
  ...$theme.borders.border100
}));
export const VerticalDivider = styled('div', ({
  $theme
}) => ({
  width: $theme.sizing.scale0,
  height: $theme.sizing.scale900,
  backgroundColor: $theme.colors.borderOpaque,
  marginLeft: $theme.sizing.scale300,
  marginRight: $theme.sizing.scale300
}));
export default Divider;